<template>
  <div class="main" id="main">
    <vNav :activeTitleL1="0"></vNav>
    <vBanna></vBanna>
    <div class="menus">
      <router-link :class="{'menu':true, 'active':activeMenu===0}" to='/introductionEn?activeMenu=0'>The Scenic Area Profile</router-link>
      <router-link :class="{'menu':true, 'active':activeMenu===1}" to='/introductionEn?activeMenu=1'>The Sceneries</router-link>
      <router-link :class="{'menu':true, 'active':activeMenu===2}" to='/introductionEn?activeMenu=2'>Guide</router-link>
    </div>
    <div class="content">
      <div class="wrap" v-show="activeMenu==0">
        <div class="innerInfo">
          <h3>The Scenic Area Profile</h3>
          <img src="images/jieshao1.jpg" alt="" srcset="">
          <p>
             The stone forest formed up in volcano eruption tens of millions of years ago when the basaltic magma was cooling and contracting into hexagonal and pentagonal columnar Joints. The cliff of over 30 m is twice the height of that in Yellow Stone Park in the US. The decorative development will lift the height to 100 m to deliver more impressive splendour.
          </p>
          <img src="images/pic4.jpg" alt="" srcset="">
        </div>
        <div class="innerInfo">
          <h3>Location</h3>
          <p>As the key scenic spot of the National Geopark of Liuhe, Guizishan Mountain Stone Forest is located approximately 17 km north of Liuhe town and adjacent to Jinniuhu Lake, with easy access by Jinjiang highway from Liuhe Downtown, Yangchu highway and the S8 Ning-Tian light rail with Babaiqiao station approximately 4 km away and Jinniuhu Lake about 2 km away. 
          </p>
          <img src="images/map.jpg" alt="" srcset="">
        </div>
        <div class="innerInfo">
          <h3>Nearby Attractions</h3>
          <p>200 m east of the stone forest is the village known as “the stone forest paiting town”,  where accommodations, hospitalities and fishing activities are at service in the resort of seven hectares. Approximately 3 km to the east is the 4A-graded Jinniuhu Lake Scenic Area (40 yuan/adult). West of Guizishan Mountain is located the the Martyrs' Cemetery (a patriotic education facility), while 5 km west along the Yang-Chu high way is situiated Pingshan Forest Park. And 11 km northeast away is seated Yeshan Hill Mine Park, which can be reached by taking No. 628 bus to Yeshan Hill terminal.
          </p>
          <div class="images">
            <div class="box1">
              <img src="images/pic10.jpg" alt="" srcset="">
              <p>Donggou Salty Goose</p>
            </div>
            <div class="box1">
              <img src="images/pic11.jpg" alt="" srcset="">
              <p>Fangshan Yuhua Tea</p>
            </div>
            <div class="box1">
              <img src="images/pic12.jpg" alt="" srcset="">
              <p>Hengliang Rain Flower Pebble Fair</p>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap" v-show="activeMenu==1">
        <h3>{{titleInfo}}</h3>
        <div class="boxs">
          <div class="box" v-for="(item, i) in infos" :key="i"  @click="goInnerWeb(item.id)">
            <img :src="item.picture" alt="" srcset="">
            <div class="title">
              <p>{{item.title}}</p>
            </div>
            <p class="info" v-html="item.descript"></p>
          </div>
        </div>
         <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="total, prev, pager, next, jumper"
            :total="totalNum"
            :page-size="3">
          </el-pagination>
      </div>
      <div class="wrap" v-show="activeMenu==2">
        <div class="innerInfo">
          <h3>Guide</h3>
            <el-image
              style="max-width:800px;"
              :src="'images/pic22.jpg'"
              :preview-src-list="['images/pic22.jpg']">
            </el-image>
          <!-- <img src="images/pic22.jpg" alt="" srcset=""> -->
          <p>
            <span style="font-weight: bold;">Price:</span><br>
            1、18 yuan/adult<br>
            2、Free admission is offered to children under 1.40 metres in height, older people of and above age 70, PLA service members, retired cadres, special-needs persons and other qualified individuals (with valid certificate). <br>
            3、Half price admission is offered to full-time students, older people of age 60 to 6 (with valid certificate).<br>
            <span style="font-weight: bold;">Transport:</span><br>Line S8 Babaiqiao station—Bus no.628 or 629—Geopark stone forest stop (Right turn at the intersection and a walk for 50 m)<br>
            <span style="font-weight: bold;">Opening Hours:</span><br>8:30-17:00, Monday—Sunday<br>
            <span style="font-weight: bold;">Recommended tour route:</span><br>The visitor centre (Start)——Geological museum——Forest Trail——Guizi Peasant Painting Corridor——Stone Forest——Wangmu Pavilion——Mountaineering Trail——Guizi Spring——Wisdom Spring——Exit (End)<br>
            <span style="font-weight: bold;">nformation hotline:</span>025-57577818<br>
            <span style="font-weight: bold;">Complaints hotline:</span>025-57573027<br>
            <span style="font-weight: bold;">Emergency hotline:</span>025-57577541<br>
            <span style="font-weight: bold;">The district tourism admin. complaints hotline: </span>025-57121982<br>
          </p>
        </div>
      </div>
    </div>
    <vBot :divStyle="true"></vBot>
    <div class="info">{{titleInfo}}</div>
  </div>
</template>
<style>
</style>
<style scoped>
.main {
  height: 100%;
  width: 100%;
  position: relative;
  background-color: white;
  overflow-x: hidden;
  overflow-y: auto;
}

.content{
  width: 100%;
  min-height: 1600px;
  position: relative;
  /* background: url(../../public/images/bgBot1.png) no-repeat; */
  /* background-size: 1920px 383px; */
  background-position-y: bottom;
}

.content .wrap{
  width: 1440px;
  height: auto;
  position: relative;
  transform: translateX(-50%);
  left: 50%;
}
.content .wrap .innerInfo{
  text-align: center;
  margin-bottom: 50px;
}
.content .wrap .innerInfo>p{
  line-height: 50px;
}
.content .wrap .innerInfo .images{
  display: flex;
  justify-content: space-around;
}
.content .wrap .innerInfo .images .box1{
  width: 400px;
  position: relative;

}
.content .wrap .innerInfo .box1 img{
  width: 400px;
  display: block;
  position: relative;
}
.content .wrap .innerInfo .box1 p{
  width: 400px;
  display: block;
  color: black;
  margin: 0;
  padding: 0;
  text-align: right;
  font-size: 16px;
}
.content .wrap .innerInfo h3{
  width: 400px;
  border-bottom: 5px solid #fca26b;
  height: 60px;
  line-height: 60px;
  font-size: 34px;
  color: #666565;
  position: relative;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}
.content .wrap .innerInfo p{
  width: 1200px;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 120px;
  font-weight: lighter;
  font-size: 20px;
}
.content .wrap .innerInfo img{
  max-width: 800px;
}
.content .wrap>h3{
  width: auto;
  height: 126px;
  line-height: 126px;
  font-size: 34px;
  color: #666565;
  position: relative;
  text-align: center;
}
.content .wrap .el-pagination{
  position: absolute;
  right: 0;
}
.content .wrap .boxs{
  width: 100%;
  height: 1300px;
  position: relative;
}
.content .wrap .box{
  width: 1306px;
  height: 416px;
  position: relative;
  margin-left: 67px;
  cursor: pointer;
}
.content .wrap .box img{
  max-width: 429px;
  max-height: 324px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.content .wrap .box .title{
  height: 90px;
  position: absolute;
  left: 520px;
  top: 44px;
  border-bottom: 3px solid #fca26b;
  vertical-align: middle;
}
.content .wrap .box .title>p{
  width: 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  color: black;
  line-height: 30px;
  font-weight: bold;
}
.content .wrap .box .info{
  width: 786px;
  height: 224px;
  position: absolute;
  left: 520px;
  bottom: 0;
  font-size: 17px;
  color: black;
  line-height: 34px;
  border-bottom: 2px solid #ebebeb;
}
.main>.info{
  position: absolute;
  font-size: 60px;
  left: 20%;
  top: 49%;
  z-index: 999;
  color: white;
}
.main .menus{
  position: relative;
  width: 100%;
  height: 56px;
  background-color: #e5e5e5;
  display: flex;
  padding-left: 240px;
  box-sizing: border-box;
}
.main .menus .menu{
  height: 56px;
  font-size: 20px;
  color: black;
  line-height: 56px;
  margin-left: 97px;
  cursor: pointer;
}
.main .menus .menu.active{
  border-bottom: 6px solid #bcbcbc;
  box-sizing: border-box;
}
</style>
<script>
import https from '@/https.js'
import '@/rem.js'
import nav from '../components/navEn'
import banna from '../components/bannaEn'
import bot from '../components/botEn'
export default {
  components: {
    vNav: nav,
    vBanna: banna,
    vBot: bot
  },
  data() {
    return {
      activeMenu: 0,
      titleInfo: 'The Scenic Area Profile',
      currentPage: 0,
      totalNum: 1,
      infos: [
      ]
    }
  },
  created() {
    this.init()
  },
  watch: {
    '$route' (to, from) {
      this.init()
    }
  },
  methods: {
    init() {
      this.activeMenu = this.$route.query.activeMenu ? parseInt(this.$route.query.activeMenu) : 0
      switch(this.activeMenu) {
        case 0:
          this.titleInfo = 'The Scenic Area Profile'
          break
        case 1:
          this.titleInfo = 'The Sceneries'
          this.mID = 'bfeb1795-7efe-4328-95fe-278e555ba3ca'
          https.fetchGet('/api/news/GetNews', {
            pageIndex: 1,
            pageSize: 3,
            menuID: this.mID,
            en:true
          }).then(res => {
            console.log(res)
            this.infos = res.data.result
            this.totalNum = res.data.count
          })
          break
        case 2:
          this.titleInfo = 'Guide'
          break
        default:
          break
      }
    },
    goInnerWeb(id) {
      this.$router.push('/introductionDEn?id=' + id)
    },
    goWeb(id) {
      this.$router.push('/index2?id=' + id)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      https.fetchGet('/api/news/GetNews', {
        pageIndex: val,
        pageSize: 3,
        menuID: 'bfeb1795-7efe-4328-95fe-278e555ba3ca',
        en:true
      }).then(res => {
        console.log(res)
        this.infos = res.data.result
        this.totalNum = res.data.count
      })
    }
  }
}
</script>
